import { useQuery, useQueryClient } from '@tanstack/react-query'
import { useEffect, useState } from 'react'
import { ApiError } from '../../api/client'
import { oncallSettingsQuery, saveOncallGroups } from '../../api/settingsEaseedeskOncall'
import { SelectPicker } from '../../ui/SelectPicker'
import { toast } from '../../ui/notify'
import { LoadFailed } from '../../ui/LoadFailed'
import { Spinner } from '../../ui/Spinner'

/**
 * Settings -> Easeedesk -> Others -> Oncall, element cu element fata de
 * `views/easeedesk_settings/others/oncall/index.php`: un selector multiplu
 * cu grupurile furnizorului (bootstrap-select, `count > 0`), butonul
 * Update si nota de dedesubt. Salvarea trimite `groups[]` ca formularul
 * vechi si spune acelasi lucru la sfarsit (`index-1.js`).
 */
export function OncallSettingsPage() {
  const client = useQueryClient()
  const page = useQuery(oncallSettingsQuery())
  const [chosen, setChosen] = useState<string[]>([])
  const [busy, setBusy] = useState(false)

  useEffect(() => {
    if (page.data) setChosen(page.data.oncall_groups.map(String))
  }, [page.data])

  if (page.error instanceof ApiError && page.error.status === 403) {
    return (
      <div className="alert alert-danger">
        <i className="fas fa-exclamation-circle" aria-hidden="true"></i> You do not have access to this action.
      </div>
    )
  }
  if (page.error) {
    return <LoadFailed error={page.error} onRetry={() => void page.refetch()} what="this screen" />
  }
  if (!page.data) return <Spinner />

  const update = () => {
    setBusy(true)
    void saveOncallGroups(chosen)
      .then(() => {
        setBusy(false)
        toast('Oncall groups have been changed.', 'Success')
        void client.invalidateQueries({ queryKey: ['settings', 'easeedesk', 'oncall'] })
      })
      .catch(() => {
        setBusy(false)
        toast('Something went wrong.', 'Error', 'error')
      })
  }

  return (
    <div>
      <h4>
        <strong>Oncall</strong> users settings
      </h4>
      <label className="color" style={{ marginBottom: 0 }}>
        Manage settings for <strong>oncall</strong> users.
      </label>
      <hr />

      <section className="settings oncall-settings">
        <form className="form-horizontal" id="oncallSettingsForm" onSubmit={(e) => e.preventDefault()}>
          <div className="form-group">
            <div className="col-md-3">
              <h5 className="pull-left" style={{ margin: 0, padding: '5px 0', marginLeft: 20 }}>
                Oncall Groups
              </h5>
            </div>
            <div className="col-md-6">
              <SelectPicker
                id="oncallGroups"
                name="groups[]"
                className="form-control"
                title="Select.."
                multiple
                selectedTextFormat="count > 0"
                options={page.data.groups.map((group) => ({ value: String(group.ID), label: group.Nume }))}
                value={chosen}
                onChange={setChosen}
              />
            </div>
            <div className="col-md-3"></div>
          </div>
        </form>

        <div className="col-md-12">
          <button className="btn btn-primary pull-right update-oncall-settings" type="button" disabled={busy} onClick={update}>
            Update
          </button>
        </div>

        <div className="col-md-12 note note-info">
          <i className="fas fa-info-circle"></i> Oncall users can be set only from the selected groups.
        </div>
      </section>
    </div>
  )
}
